import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import easter from 'date-easter';
import CalDate from 'caldate';
import CalEvent from './CalEvent.js';
var Easter = /*#__PURE__*/function (_CalEvent) {
  _inherits(Easter, _CalEvent);
  var _super = _createSuper(Easter);
  /**
   * @param {object} [opts]
   * @param {string} opts.type - type of eastern (easter|orthodox)
   * @param {number|string} opts.offset - offset in days
   */
  function Easter(opts) {
    var _this;
    _classCallCheck(this, Easter);
    opts = opts || {};
    _this = _super.call(this, opts);
    _this._fn = easter.easter;
    if (opts.type === 'orthodox') {
      _this._fn = easter.orthodoxEaster;
    }
    return _this;
  }
  _createClass(Easter, [{
    key: "inYear",
    value: function inYear(year) {
      var d = new CalDate(this._fn(year)).setOffset(this.offset);
      this.dates.push(d);
      return this;
    }
  }]);
  return Easter;
}(CalEvent);
export { Easter as default };